<ch-header></ch-header>
<div class="container-fluid">
  <div class="row">
    <ch-sidebar></ch-sidebar>
    <!-- <main class="col-sm-9 col-sm-offset-3 col-md-10 col-md-offset-2 app-body"> -->
    <main class="app-body"><router-outlet></router-outlet></main>
  </div>
</div>



// WEBPACK FOOTER //
// /Users/thxgg/Projects/Work/code-hospitality-cms/src/app/core/admin/admin.component.html